import { render, staticRenderFns } from "./MarketEdit.vue?vue&type=template&id=7cb6a485&"
import script from "./MarketEdit.vue?vue&type=script&lang=js&"
export * from "./MarketEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports